import { render } from "./BusquedaPacientes.vue?vue&type=template&id=bfd723dc&scoped=true"
import script from "./BusquedaPacientes.vue?vue&type=script&lang=js"
export * from "./BusquedaPacientes.vue?vue&type=script&lang=js"

import "./BusquedaPacientes.vue?vue&type=style&index=0&id=bfd723dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd723dc"]])

export default __exports__